/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable complexity */
/* eslint-disable no-shadow */
// Extended by FormComponent
import _ from 'lodash';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import TopBackButton from '../BackButton/TopBackButton';
import BottomBackButton from '../BackButton/BottomBackButton';
import ExitButton from '../ExitButton';
import ExitWithoutSavingButton from '../ExitWithoutSavingButton';
import Stepper from '../Stepper';
import { Events } from '../../utils/dom/html-events';
import { ClassNames } from '../../utils/dom/css-classes';
import { coreQuestionRenderers } from './questionRenderers';
import { QuestionTypes, FormTypes } from './questionTypes';

export { QuestionTypes, FormTypes };

const HIDE_CLASS = 'u-hidden';
export default class FormGenerator extends FormComponent {
	get questions() {
		return this._questions;
	}

	set questions(_questions) {
		this._questions = _questions.filter((question) => !!question?.id);
	}

	get answers() {
		return this._answers;
	}

	set answers(_answers) {
		// eslint-disable-next-line no-console
		console.log({ _answers });
		this._answers = _answers;
	}

	get currentStep() {
		return this._currentStep;
	}

	set currentStep(_step) {
		this._currentStep = _step;
		if (this.data) {
			if (!this.isSectionForm) {
				this.updateStep();
			}
			this.updateStepButtonLabel();
		}
	}

	constructor(containerElement, config) {
		super(containerElement, config);
		this.currentStep = 1;
		this._stepChangeCallbacks = [];
		this._submitHandler = [];
		this.classPrefix = 'lta-form-generator';
		this.answers = {};
		this.totalSteps = config.totalSteps || 3;
		this.stepVisibility =
			config?.stepVisibility?.length > 0 ? config?.stepVisibility : this.stepVisibilityEnable(this.totalSteps);
		this.hasQuestionSteps = [...this.stepVisibility];
		this.questions = _.cloneDeep(config.questions);
		// Must be set before this.data — FormComponent's data setter calls render() → renderQuestions()
		this.questionRenderers = {
			...coreQuestionRenderers,
			...(config.questionRenderers || {})
		};
		this.formType = config?.formType;
		this.isRenderDependentQuestion = true;
		this.conditionalStepsVisiblity = !!config?.conditionalStepsVisiblity;
		this.data = config;
	}
	stepVisibilityEnable(totalSteps) {
		const stepsVisibilityArray = [];
		for (let index = 0; index < totalSteps; index++) {
			stepsVisibilityArray.push(true);
		}
		return stepsVisibilityArray;
	}
	onStepChange(callback) {
		this._stepChangeCallbacks.push(callback);
	}
	onSubmit(callback) {
		this._submitHandler.push(callback);
	}
	afterStepChange(step) {
		for (const callback of this._stepChangeCallbacks) {
			callback(step);
		}
		this.reRenderStepQuestions(step);
		        this.scrollStepIntoView();
    }
 
    /**
     * Scrolls the user back to the top of the current step whenever the step
     * changes (next or back), so multi-step forms/modals always start each
     * new step from the beginning instead of keeping the previous scroll
     * position.
     *
     * Rather than guessing which ancestor is the actual scrolling container
     * (window, `.lta-modal`, `.lta-modal-content`, etc. - this varies between
     * modal / non-modal usage and fullscreen / non-fullscreen dialogs), this
     * uses the step element's own `scrollIntoView()`, which lets the browser
     * walk up the DOM and adjust whichever ancestor(s) are actually
     * scrollable. It's run on the next two animation frames (and a short
     * timeout as a last resort) to land after layout has settled and to
     * override any scroll-anchoring the browser applies as content resizes.
     */
    scrollStepIntoView() {
        requestAnimationFrame(() => {
            const modalContentEl = this.containerEl?.closest?.('.lta-modal-content');
            const modalEl = this.containerEl?.closest?.('.lta-modal');

            for (const target of [modalContentEl, modalEl].filter(Boolean)) {
                target.scrollTop = 0;
            }

            window.scrollTo(0, 0);
        });
    }
	

	reRenderStepQuestions(step) {
		const stepQuestions = this.questions.filter((question) => question.step === step);
		stepQuestions.forEach((question) => {
			// if (question.visible && !question.ref) {
			// 	this.renderQuestion(question);
			// }

			if (question?.ref?.data?.shouldReRenderOnStepChange && question?.ref?.data?.visible) {
				question?.ref?.render();
			}
		});
	}

	submitForm() {
		for (const callback of this._submitHandler) {
			callback(this.answers, this.value);
		}
	}
	markup() {
		const themeColor = this.data?.themeColor;
		if (this.data.isBackButtonEnabled) {
			this.topBackButton = new TopBackButton(this.containerEl, { classPrefix: this.classPrefix });
		}
		if (this.data.isExitButtonEnabled) {
			this.exitButton = new ExitButton(this.containerEl, {
				classPrefix: this.classPrefix,
				buttonLabel: this.data?.exitButtonLabel,
				exitButtonClasses: this.data?.exitButtonClasses
			});
		}
		if (this.data?.showBottomBackButton) {
			this.bottomBackButton = new BottomBackButton(this.containerEl, {
				classPrefix: this.classPrefix,
				backStepButtonLabel: this.data?.backStepButtonLabel,
				backStepButtonClasses: this.data?.backStepButtonClasses
			});
		}
		if (this.data?.showExitWithoutSavingButton) {
			this.exitWithoutSavingButton = new ExitWithoutSavingButton(this.containerEl, {
				classPrefix: this.classPrefix,
				exitWithoutSavingButtonLabel: this.data?.exitWithoutSavingButtonLabel,
				exitWithoutSavingButtonClasses: this.data?.exitWithoutSavingButtonClasses
			});
		}

		if (!this.data?.isHideProgress) {
			this.stepper = new Stepper(this.containerEl, {
				classPrefix: this.classPrefix,
				stepTitle: this.getStepTitle(),
				totalSteps: this.totalSteps,
				currentStep: this.currentStep,
				stepVisibility: this.stepVisibility,
				themeColor
			});
		}

		const buttonTitle = this.updateStepButtonLabel();
		this.isSectionForm = this.data?.formType === FormTypes.SectionForm;
		this.isSeparator = !!this.data?.isSeparator;
		this.mainPageElement = this.data?.mainPageElement;
		this.setBackgroundColor();
		const formWrapperModifier = this.data?.isHideProgress ? `${this.classPrefix}__form-wrapper--no-stepper` : '';

		return `
			<div class="${this.classPrefix}__form-action-button-container">
				<div class="${this.classPrefix}__form-action-button-inner">
					<div>
						${this.topBackButton?.markup() || ''}
					</div>
					<div>
						${this.exitButton?.markup() || ''}
					</div>
				</div>
			</div>
            <div class="${this.classPrefix}__form-wrapper ${formWrapperModifier}" style="--lta-theme--1: var(--${themeColor})">
				${this.stepper?.markup() || ''}
				<div class="${this.classPrefix}__form-container">${this.renderFormContainer()}</div>
				<div class="${this.classPrefix}__form-next ${this.isSectionForm && !this.data?.submitButton?.alwaysVisible ? ClassNames.Hidden : ''}">
                    <button 
						type="button" 
						class="lta-btn lta-btn--default lta-btn--primary lta-btn--block js-form-generator-next-button ${this.classPrefix}__form-next-button ${this.data?.submitButton?.classes || ''}" 
						data-target="${this.data?.submitButton?.dataTarget}"
					>
						${buttonTitle}
					</button>

					<div>
						${this.exitWithoutSavingButton?.markup() || ''}
					</div>
					
					<div>
						${this.bottomBackButton?.markup() || ''}
					</div>
                </div>
            </div>
        `;
	}

	afterRender() {
		this.nextButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-next-button`, this.containerEl);
		this.topBackButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this.containerEl);
		this.exitButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-exit-button`, this.containerEl);
		this.exitWithoutSavingButtonEl = SelectorEngine.findOne(
			`.${this.classPrefix}__form-exit-without-saving-button`,
			this.containerEl
		);
		this.bottomBackButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-back-step-button`, this.containerEl);
		this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
		this.renderQuestions();
		this.updateHasQuestionSteps();
		this.setUpForwardAndBackEvents();
		this.backButtonToggle();
		// Get button reference.
	}

	reRenderForm(updatedStepData) {
		if (this.nextButtonEl) {
			this.nextButtonEl.disabled = false;
		}
		this.currentStep = updatedStepData?.[0]?.step;
		const question = this.questions?.find((question) => question?.id === updatedStepData?.[0]?.id);
		question?.ref?.reRenderQuestion(updatedStepData?.[0]?.supportingProps);
		this.nextButtonToggle();
	}

	setUpForwardAndBackEvents() {
		if (this.nextButtonEl) {
			EventHandler.on(this.nextButtonEl, Events.Click, (event) => {
				this.nextButtonClickHandler(event);
			});
		}

		if (this.topBackButtonEl) {
			EventHandler.on(this.topBackButtonEl, Events.Click, () => {
				if (this.currentStep === 1) {
					if (this.data?.backButtonHandlerFirstStep) {
						// A handler can return `false` to signal that the step's content
						// shouldn't be torn down (e.g. it switched to a different internal
						// view rather than closing the form) - anything else preserves the
						// original always-unload behaviour.
						const shouldUnload = this.data?.backButtonHandlerFirstStep() !== false;

						if (shouldUnload) {
							this.unload();
						}
					} else {
						window?.history?.back();
					}
				} else {
					this.backButtonClickHandler();
				}
			});
		}

		if (this.exitButtonEl) {
			EventHandler.on(this.exitButtonEl, Events.Click, () => {
				this.data?.exitButtonHandler?.();
			});
		}

		if (this.exitWithoutSavingButtonEl) {
			EventHandler.on(this.exitWithoutSavingButtonEl, Events.Click, () => {
				this.data?.exitWithoutSavingButtonHandler?.();
			});
		}

		if (this.bottomBackButtonEl) {
			EventHandler.on(this.bottomBackButtonEl, Events.Click, () => {
				if (this.currentStep > 1) {
					this.backButtonClickHandler();
				}
			});
		}
	}

	async nextButtonClickHandler(event) {
		const valid = await this.stepValidator(this.currentStep);
		if (!valid) {
			this.backButtonToggle();
			return;
		}

		this.updateHasQuestionSteps();
		const nextStep = this.findNextStepWithQuestions(this.currentStep + 1);

		if (nextStep === null) {
			event.target.disabled = true;
			this.value = this.answers;
			this.submitForm();
		} else {
			this.currentStep = nextStep;
			this.afterStepChange(this.currentStep);
			this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
			this.performActionOnNextStep();
			this.setBackgroundColor();
		}
		this.backButtonToggle();
	}

	enableSubmitButton() {
		const submitButton = SelectorEngine.findOne('.js-form-generator-next-button', this.containerEl);
		if (submitButton && this.currentStep === this.totalSteps) {
			submitButton.disabled = false;
		}
	}

	performActionOnNextStep() {
		const stepQuestion = this.questions.find((question) => question.step === this.currentStep);
		if (stepQuestion?.ref?.data?.hasPerformActionOnload) {
			stepQuestion?.ref?.performActionOnLoad();
		}
	}

	/**
	 * Whether a step has at least one question that should be shown to the user.
	 * Accounts for visibility and shouldRender() overrides (e.g. childContactNumber).
	 */
	stepHasActiveQuestions(step) {
		return this.questions.some((question) => {
			if (question.step !== step || !question.visible) {
				return false;
			}
			if (typeof question?.ref?.shouldRender === 'function' && question.ref.shouldRender() === false) {
				return false;
			}
			return true;
		});
	}

	updateHasQuestionSteps() {
		for (let index = 0; index < this.totalSteps; index++) {
			this.hasQuestionSteps[index] = this.stepHasActiveQuestions(index + 1);
		}
	}

	findNextStepWithQuestions(fromStep) {
		for (let step = fromStep; step <= this.totalSteps; step++) {
			if (this.stepHasActiveQuestions(step)) {
				return step;
			}
		}
		return null;
	}

	findPreviousStepWithQuestions(fromStep) {
		for (let step = fromStep; step >= 1; step--) {
			if (this.stepHasActiveQuestions(step)) {
				return step;
			}
		}
		return 1;
	}

	checkQuestionNextClick(steps) {
		const nextStep = this.findNextStepWithQuestions(steps + 1);
		if (nextStep !== null) {
			this.currentStep = nextStep;
			return this.currentStep;
		}
		this.currentStep = this.totalSteps;
		return this.currentStep;
	}

	checkQuestionBackClick(steps) {
		this.currentStep = this.findPreviousStepWithQuestions(steps + 1);
		return this.currentStep;
	}

	backButtonClickHandler() {
		this.updateHasQuestionSteps();
		this.currentStep = this.findPreviousStepWithQuestions(this.currentStep - 1);
		this.afterStepChange(this.currentStep);
		this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
		this.setBackgroundColor();
		this.nextButtonToggle();
		this.backButtonToggle();
	}

	hideShowStepper(value) {
		if (!this.conditionalStepsVisiblity) {
			return;
		}
		const stepperElement = SelectorEngine.findOne(`.lta-steps`, this.containerEl);
		if (value) {
			stepperElement?.classList.remove(HIDE_CLASS);
		} else {
			stepperElement?.classList.add(HIDE_CLASS);
		}

		if (stepperElement) {
			for (let index = 0; index < this.totalSteps; index++) {
				const hideStepperElement = SelectorEngine.findOne(`.lta-steps__item-${index + 1}`, this.containerEl);
				if (this.stepVisibility[index] && !this.hasQuestionSteps[index]) {
					hideStepperElement.classList.add('lta-steps_visibility-hidden');
				}
			}
		}
	}

	setBackgroundColor() {
		if (this.mainPageElement) {
			const stepQuestion = this.questions.find((question) => question.step === this.currentStep);
			const backgroundColorClassData = stepQuestion?.backgroundColorClass
				? stepQuestion?.backgroundColorClass
				: 'u-bg-white';
			for (let index = 0; index < this.mainPageElement.classList.length; index++) {
				if (this.mainPageElement.classList[index].includes('u-bg')) {
					this.mainPageElement.classList.remove(this.mainPageElement.classList[index]);
				}
			}
			this.mainPageElement.classList.add(backgroundColorClassData);
		}
	}

	async formValidation() {
		for (let index = 0; index < this.totalSteps; index++) {
			const isCurrentValid = await this.stepValidator(index + 1);
			if (!isCurrentValid) {
				return false;
			}
		}
		this.value = this.answers;
		return true;
	}

	renderFormContainer() {
		return Array.from({ length: this.totalSteps })
			.map(
				(__, index) => `
            <div class="${this.classPrefix}__step js-form-generator-step-${index + 1} ${
					!this.isSectionForm && index > 0 ? ClassNames.Hidden : ''
				} ${this.data?.wrapperClasses?.[index] || ''}">
                ${
									this.isSeparator && index !== 0 && index < this.totalSteps
										? `<div class="sectionSeparator u-mb-5"></div>`
										: ``
								}
                ${
									this.isSectionForm
										? `<div class="lta-form-generator__section-title u-mb-2 md:u-mb-3">${this.renderSectionTitle(
												index + 1
										  )}</div>`
										: ''
								}
                ${this.renderQuestionContainers(index + 1)}
            </div>
        `
			)
			.join('');
	}

	renderSectionTitle(step) {
		const questionTitleArray = this.questions
			?.filter((question) => !!question)
			?.filter((question) => question.step === step)
			.map((question) => question?.stepTitle);
		const titleArray = [...new Set(questionTitleArray)];
		return titleArray[0] || '';
	}

	renderQuestionContainers(step) {
		return this.questions
			?.filter((question) => !!question)
			?.filter((question) => question.step === step)
			.map(
				(question, index) => `
                    <div class="${this.classPrefix}__question-container js-form-generator-question-${
					question.id
				} ${question.isGroup ? `${this.classPrefix}__question-group` : ''} ${
					this.data?.hasSeparator && index !== 0 ? `${this.classPrefix}-has-separator` : ''
				}  lta-heading"></div>
                `
			)
			.join('');
	}

	renderQuestions() {
		for (const question of this.questions) {
			if (question?.visible) {
				this.renderQuestion(question);
			} else {
				// Remove question instance and reference.
				this.removeQuestion(question);
			}
		}
	}

	removeDependentQuestions(previousDependentQuestion) {
		if (
			previousDependentQuestion?.questionType === QuestionTypes.Radio ||
			previousDependentQuestion?.questionType === QuestionTypes.Checkbox
		) {
			for (let index = 0; index < previousDependentQuestion?.options?.length; index++) {
				this.setVisibilityHide(previousDependentQuestion?.options[index]?.dependentQuestion);
			}
		} else {
			this.setVisibilityHide(previousDependentQuestion?.dependentQuestion);
		}
	}

	clearQuestionAnswer(question) {
		if (!question?.step || !this.answers?.[question.step]) {
			return;
		}

		const stepAnswers = { ...this.answers[question.step] };
		delete stepAnswers[question.id];
		this.answers = {
			...this.answers,
			[question.step]: stepAnswers
		};
	}

	setVisibilityHide(dependentQuestions = []) {
		for (let index = 0; index < dependentQuestions?.length; index++) {
			const dependentQuestion = this.questions.find((question) => question.id === dependentQuestions[index]);
			if (dependentQuestion) {
				this.removeDependentQuestions(dependentQuestion);
				dependentQuestion.visible = false;
				this.clearQuestionAnswer(dependentQuestion);
			}
		}
	}

	beforeDepChangeHandler(newDeps, previousDeps) {
		// Hide previous dependent Question
		previousDeps?.forEach((id) => {
			const previousDependentQuestion = this.questions.find((question) => question.id === id);
			if (previousDependentQuestion) {
				previousDependentQuestion.visible = false;
				this.removeDependentQuestions(previousDependentQuestion);
				if (!newDeps?.includes(id)) {
					this.clearQuestionAnswer(previousDependentQuestion);
				}
			}
		});

		if (this.isRenderDependentQuestion) {
			this.renderQuestions();
		}

		// Show dependent Question
		newDeps?.forEach((id) => {
			const dependentQuestion = this.questions.find((question) => question.id === id);
			if (dependentQuestion) {
				this.updateAnswers(dependentQuestion, this?.answers?.[dependentQuestion?.step]?.[id] || '');
				dependentQuestion.visible = true;
			}
		});

		if (this.isRenderDependentQuestion) {
			this.renderQuestions();
		}
		this.checkStepsOnSelection();
	}

	checkStepsOnSelection() {
		this.updateHasQuestionSteps();
	}

	renderQuestion(question) {
		if (question.ref || question._isRendering) {
			return;
		}

		const commonConfig = {
			beforeDependentQuestionChange: (...args) => this.beforeDepChangeHandler(...args),
			titlePattern: this.data?.titlePattern,
			goBack: () => {
				if (this.currentStep > 0) {
					this.currentStep = this.currentStep - 1;
				}
			}
		};

		const questionContainer = SelectorEngine.findOne(`.js-form-generator-question-${question.id}`, this.containerEl);
		const renderer = this.questionRenderers?.[question.questionType];

		if (!renderer) {
			// eslint-disable-next-line no-console
			console.error(`Question type ${question.questionType} is not recognised`);
			return;
		}

		// Guard against constructors that fire dependent-question updates before
		// `question.ref` is assigned (e.g. SessionPlayersList.setupValueObject).
		question._isRendering = true;
		try {
			question.ref = renderer(this, question, questionContainer, commonConfig);
			this.initQuestionEventHandlers(question);
		} finally {
			question._isRendering = false;
		}
	}

	initQuestionEventHandlers(question) {
		question.ref?.onChange((answer, previousValue) => {
			this.updateAnswers(question, answer, previousValue);
			this.nextButtonToggle();
		});

		// Some question types (e.g. ManualContactCard) can emit an initial value during
		// construction, before the onChange listener above is registered. Seed the answer
		// here so pre-filled values are captured without requiring user interaction.
		if (question.ref?.value !== undefined) {
			this.updateAnswers(question, question.ref.value);
		}
	}

	removeQuestion(question) {
		if (typeof question?.ref?.destroy === 'function') {
			question.ref.destroy();
		} else {
			question?.ref?.remove();
		}
		delete question?.ref;
	}

	updateAnswers(question, answer) {
		this.answers = {
			...this.answers,
			[question.step]: {
				...this.answers?.[question.step],
				[question.id]: answer
			}
		};
	}

	getStepTitle() {
		const stepQuestion = this.questions.find((question) => question.step === this.currentStep && question.visible);
		return stepQuestion?.stepperTitle || this.data?.stepTitle || 'Your school';
	}

	updateStep() {
		if (this.stepper) {
			this.stepper.updateState({ stepTitle: this.getStepTitle(), currentStepCount: this.currentStep });
			const existingStepperComponentWrapper = SelectorEngine.findOne(`.${this.classPrefix}__stepper`, this._element);
			existingStepperComponentWrapper.innerHTML = this.stepper.markup();
		}
		// Hide all steps.
		const previousStepContainers = SelectorEngine.find(
			`.${this.classPrefix}__step:not(.${ClassNames.Hidden})`,
			this.containerEl
		);
		if (previousStepContainers?.length > 0) {
			for (const previousStepContainer of previousStepContainers) {
				this.hide(previousStepContainer);
			}
		}

		// Show the current step.
		const currentStepContainer = SelectorEngine.findOne(
			`.js-form-generator-step-${this.currentStep}`,
			this.containerEl
		);
		!!currentStepContainer && this.show(currentStepContainer);

		this.updateStepButtonLabel();
		requestAnimationFrame(() => {
			this.nextButtonToggle();
			this.backButtonToggle();
		});
	}

	nextButtonToggle() {
		const isButtonVisible = this.nextValidator(this.currentStep);
		if (isButtonVisible) {
			this.nextButtonEl?.classList.remove(HIDE_CLASS);
		} else {
			this.nextButtonEl?.classList.add(HIDE_CLASS);
		}
	}

	backButtonToggle() {
		if (!this.bottomBackButton) return;

		if (this.currentStep > 1) {
			this.bottomBackButton.show();
		} else {
			this.bottomBackButton.hide();
		}
	}

	updateStepButtonLabel() {
		let buttonLabel = this.data?.nextStepButtonLabel || 'Next';
		if (this.currentStep === this.totalSteps) {
			buttonLabel = this.data?.submitButton?.title || 'Next';
		}
		if (this.nextButtonEl) this.nextButtonEl.innerHTML = buttonLabel;
		return buttonLabel;
	}

	async stepValidator(step) {
		// Check if questions on current step are answered.
		const stepsValidator = [];
		const questionList = this.questions.filter((question) => question.step === step);

		for (const question of questionList) {
			if (question?.ref?.shouldRender && question?.ref?.shouldRender?.() === false) {
				// NOTE: shouldRender is a method that can be overridden by the question type to implement logic to show / hide the question.
				// Currently only SessionPlayersList overrides this method to show/hide the question based on the number of players in the session.
				continue;
			}
			const currentAnswerIsValid = await question?.ref?.validate(true);
			const currentAnswer = this.answers?.[question.step]?.[question.id];

			// TODO: This 'N/A' hack shouldn't be here
			if (!question.visible || question.isOptional || currentAnswer?.value === 'N/A') {
				 continue;
			}
			// TODO: We should avoid checking .value here, and rely on the validate() method from the question type
			if (currentAnswerIsValid === false || currentAnswer?.value === undefined || currentAnswer?.value === null) {
				stepsValidator.push(false);
			}
		}
		return stepsValidator?.includes(false) ? false : true;
	}

	nextValidator(step) {
		return (
			this.questions.filter((question) => {
				if (question.step === step && question.visible && !question.isOptional) {
					return question?.ref?.shouldShowNext ? !question.ref.shouldShowNext() : false;
				}
				return false;
			})?.length === 0
		);
	}

	getAnswerByQuestionType(questionType, instance = 0) {
		const { step, id } = this.questions.filter((question) => question.questionType === questionType)[instance];
		return this.answers?.[step]?.[id]?.value;
	}

	hide(element) {
		element.classList?.add(ClassNames.Hidden);
	}

	show(element) {
		element.classList?.remove(ClassNames.Hidden);
	}

	unload() {
		for (const question of this.questions) {
			this.removeQuestion(question);
		}
		this.containerEl.innerHTML = '';
	}
}

/* eslint-enable unicorn/no-array-for-each */
/* eslint-enable complexity */
/* eslint-enable no-shadow */
